import { Button, Heading, Icon, Modal, Paragraph } from '@zillow/constellation-10';
import { IconWarningFilled } from '@zillow/constellation-icons';

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
};

/** Shown once when the AI draft errors; dismissing either way leaves the manual form in place. */
const AiDraftFailedModal = ({ isOpen, onDismiss }: Props) => (
  <Modal
    size="sm"
    dividers={false}
    open={isOpen}
    onOpenChange={(open) => !open && onDismiss()}
    header={<Icon render={<IconWarningFilled />} size="md" css={{ color: 'icon.feedback.warning.hero' }} />}
    body={
      <>
        <Heading level={2} textStyle="heading-xs" css={{ marginBottom: 'tightest' }}>
          Property description and amenities selection failed
        </Heading>
        <Paragraph textStyle="body-sm">
          The AI ran into an issue processing your photos and notes. You can wait and try again later, or write your
          property description and select amenities manually.
        </Paragraph>
      </>
    }
    footer={
      <Button onClick={onDismiss} data-testid="ai-draft-complete-manually">
        Complete manually
      </Button>
    }
  />
);

export default AiDraftFailedModal;
